// extracted by mini-css-extract-plugin
export default {"container":"Products_container__qSU7h","products":"Products_products__SOyuI","menu":"Products_menu__3qIaw","list":"Products_list__E5Knt","product":"Products_product__jQU+o"};